<app-section #parentSection
             [formConfig]="formConfig"
             [formGroup]="formGroup"
             [key]="key"
             class="insurer-data-section"
             [sectionRef]="section"
             [dropdown]="false"
             [title]="null">

    <ng-template #section>

        <app-address-data
                    class="address-data"
                    [formGroup]="ownerFormArray.at(0)"
                    [formConfig]="ownerFormService.formConfig"
                    [formFactoryService]="ownerFormService"
                    [isOwner]="true"
                    [parentSection]="parentSection"
                    (changeEvent)="onFieldChange($event)"
        >
        </app-address-data>

        <app-address-data *ngFor="let coOwner of coOwnersList; let i = index"
                    [index]="i"
                    class="address-data"
                    [coOwner]="coOwner"
                    [formGroup]="coOwnersFormArray.at(i)"
                    [formConfig]="coOwnersFormServices[i].formConfig"
                    [formFactoryService]="coOwnersFormServices[i]"
                    [isOwner]="false"
                    [parentSection]="parentSection"
                    (changeEvent)="onFieldChange($event)"
        >
        </app-address-data>

        <div    *ngIf="stateService.separateInsurerAvailable"
                class="insurer-data-section__separate-insurer">
            <div class="section__component insurer-data-section__separate-insurer__checkbox">
                <mat-checkbox [checked]="stateService.separateInsurer"
                              (change)="stateService.changeSeparateInsurer($event.checked)">
                    {{ 'INSURER_DATA_SECTION.FORM_FIELDS.separateInsurer' | translate }}
                </mat-checkbox>
            </div>

            <app-separate-insurer-data-section *ngIf="stateService.separateInsurer"
                                                #separateInsurerDataSection>
            </app-separate-insurer-data-section>
        </div>

        <app-contact-insurer-data-section #contactInsurerDataSection
                                          (sectionFieldChange)="onFieldChange($event)"
        >
        </app-contact-insurer-data-section>

    </ng-template>

</app-section>
